































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import Quote from '@/models/Quote';
import Reservation from '@/models/Reservation';
import { format } from 'date-fns';

const Setup = Vue.extend({
	name: 'ReservationQuoteDetailsPopover',
	props: {
		quote: Object,
		reservation: Object,
		size: String,
	},
	computed: {
		settings(): Locations.Settings {
			return this.$store.getters['location/settings'];
		},
	},
	methods: {
		format_date(item: any): string {
			const fmt = this.quote.details.calendar_day ? 'MM/DD' : 'MM/DD HH:mm';
			return format(new Date(item.start_date * 1000), fmt);
		},

		showDetails() {
			this.$store.dispatch('googleEvents/showQuoteDetails', {
				theQuote: this.quote,
				fromClickingWidgetExtraInfo: '',
			});
		},
	},
});

@Component
export default class ReservationQuoteDetailsPopover extends Setup {
	// Props
	public quote!: Quote;
	public reservation!: Reservation;
	public size!: string;
}
